module.exports = __webpack_public_path__ + "img/25_53.5ffbc2af.png";